// extracted by mini-css-extract-plugin
export default {"wrapper":"ExpandIcon_wrapper__i3VG+","expand":"ExpandIcon_expand__D+KsB","expand___rotate":"ExpandIcon_expand___rotate__yRS54","folder":"ExpandIcon_folder__FoN2G"};